import type { UserRegistrationData } from './model';
import type { RegistrationDto } from './dto';

export function mapModelToDto(userRegistrationData: UserRegistrationData): RegistrationDto {
  return <RegistrationDto>{
    recaptcha: userRegistrationData.recaptcha,
    name: userRegistrationData.name,
    email: userRegistrationData.email,
    password: userRegistrationData.password,
    terms: userRegistrationData.terms,
    email_verification_code: userRegistrationData.emailVerificationCode,
    email_verification_vid: userRegistrationData.emailVerificationVid,
    campaign_hash: userRegistrationData.campaignHash,
    experiment_tag: userRegistrationData.experimentTag,
    persistent_anonymous_id: userRegistrationData.persistentAnonymousId,
    picture: userRegistrationData.picture,
    plan: userRegistrationData.plan,
    pricing_table: userRegistrationData.pricingTable,
    sso_provider: userRegistrationData.ssoProvider,
    sso_token: userRegistrationData.ssoToken,
    locale: userRegistrationData.locale,
  };
}
